/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { JsonApiLinksDto } from "../JsonApiLinksDto";
import type { PaginationMeta } from "../PaginationMeta";

export type HierarchiesControllerGetChildrenPathParams = {
    /**
     * @description Parent scope ID
     * @type string
    */
    scopeId: string;
};

export const hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum = {
    "ORGANIZATION": "ORGANIZATION",
    "PROMPT": "PROMPT",
    "FILE": "FILE",
    "PROJECT": "PROJECT",
    "SYSTEM": "SYSTEM",
    "WORKSPACE": "WORKSPACE",
    "TEAM": "TEAM",
    "FOLDER": "FOLDER",
    "USER": "USER",
    "CHAT_MESSAGE": "CHAT_MESSAGE",
    "CLIENT": "CLIENT",
    "THREAD": "THREAD",
    "PROJECT_TYPE": "PROJECT_TYPE",
    "OWNER": "OWNER",
    "ARCHITECT": "ARCHITECT",
    "DEPARTMENT": "DEPARTMENT",
    "REGION": "REGION",
    "CHECKLIST_TEMPLATE": "CHECKLIST_TEMPLATE",
    "TRIAL": "TRIAL",
    "CHANGE_ORDER": "CHANGE_ORDER",
    "SOURCE_RECORD": "SOURCE_RECORD",
    "all": "all"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum];

export const hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum = {
    "PENDING": "PENDING",
    "UPLOADING": "UPLOADING",
    "UPLOADED": "UPLOADED",
    "PROCESSING": "PROCESSING",
    "READY": "READY",
    "FAILED": "FAILED",
    "ARCHIVED": "ARCHIVED",
    "DELETED": "DELETED",
    "VERSIONED": "VERSIONED"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum];

export const hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum = {
    "PRIME_CONTRACT": "PRIME_CONTRACT",
    "SUBCONTRACT": "SUBCONTRACT",
    "SPECIFICATIONS": "SPECIFICATIONS",
    "DRAWING": "DRAWING",
    "DRAWING_SET": "DRAWING_SET",
    "OTHER": "OTHER"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum];

export type HierarchiesControllerGetChildrenQueryParams = {
    /**
     * @description Type(s) of scope for filtering child scopes. Can be a single type or comma-separated list (e.g., FILE,FOLDER)
     * @type string | undefined
    */
    scopeType?: HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey;
    /**
     * @description Maximum depth of hierarchy to retrieve
     * @minLength 1
     * @default 5
     * @type number | undefined
    */
    maxDepth?: number;
    /**
     * @description Load children lazily (returns links for children instead of full data)
     * @default false
     * @type boolean | undefined
    */
    lazyLoadChildren?: boolean;
    /**
     * @description Number of items per page
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    pageSize?: number;
    /**
     * @description Page number for offset-based pagination
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Sort field and order. Entity-based sorts: \"name\"/\"-name\" (entity name, case-insensitive), \"entityCreatedAt\"/\"-entityCreatedAt\", \"entityUpdatedAt\"/\"-entityUpdatedAt\", \"entityCreatedByUser\"/\"-entityCreatedByUser\" (creator full name), \"entityUpdatedByUser\"/\"-entityUpdatedByUser\" (updater full name), \"entityDocumentType\"/\"-entityDocumentType\" (file document type, alphabetical by label). Scope-based sorts: \"createdAt\"/\"-createdAt\", \"updatedAt\"/\"-updatedAt\".
     * @type string | undefined
    */
    sort?: string;
    /**
     * @description Search term to filter children by entity name, and description/referenceNumber for projects (case-insensitive partial match)
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Include soft-deleted entities (teams, organizations, clients) in the response. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description Return only archived projects, folders and files. This is what the Archive listing reads; it overrides includeArchived.
     * @default false
     * @type boolean | undefined
    */
    archiveView?: boolean;
    /**
     * @description Include archived projects, folders and files in the response. Default is false, so an archived item leaves the active listing the way a deleted one does.
     * @default false
     * @type boolean | undefined
    */
    includeArchived?: boolean;
    /**
     * @description Include the scope itself (the scopeId used in the request) in the ancestor results. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeSelf?: boolean;
    /**
     * @description File statuses to exclude from results. Can be a single status or comma-separated list (e.g., \"PENDING,UPLOADING\")
     * @type array | undefined
    */
    excludeFileStatuses?: HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey[];
    /**
     * @description Document types to filter FILE children by. Can be a single type or comma-separated list (e.g., \"PRIME_CONTRACT,SUBCONTRACT\"). Unlike excludeFileStatuses, this narrows results to files only — non-FILE children (folders) are excluded while it is active.
     * @type array | undefined
    */
    fileDocumentTypes?: HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey[];
    /**
     * @description Load entity data (folder.name, file.fileName, etc.) so results carry real display names. Set false when only counts/structure are needed, to skip the entity joins. Default is true; ignored (forced on) when a search term is present, since name filtering requires it.
     * @default true
     * @type boolean | undefined
    */
    includeEntities?: boolean;
};

export const dataTypeEnum3011 = {
    "hierarchies": "hierarchies"
} as const;

export type DataTypeEnum3011Key = (typeof dataTypeEnum3011)[keyof typeof dataTypeEnum3011];

export const attributesTypeEnum8 = {
    "ORGANIZATION": "ORGANIZATION",
    "TEAM": "TEAM",
    "PROJECT": "PROJECT",
    "FILE": "FILE",
    "FOLDER": "FOLDER",
    "CLIENT": "CLIENT"
} as const;

export type AttributesTypeEnum8Key = (typeof attributesTypeEnum8)[keyof typeof attributesTypeEnum8];

export const dataTypeEnum3012 = {
    "organizations": "organizations"
} as const;

export type DataTypeEnum3012Key = (typeof dataTypeEnum3012)[keyof typeof dataTypeEnum3012];

export const dataTypeEnum3013 = {
    "teams": "teams"
} as const;

export type DataTypeEnum3013Key = (typeof dataTypeEnum3013)[keyof typeof dataTypeEnum3013];

export const dataTypeEnum3014 = {
    "projects": "projects"
} as const;

export type DataTypeEnum3014Key = (typeof dataTypeEnum3014)[keyof typeof dataTypeEnum3014];

export const dataTypeEnum3015 = {
    "files": "files"
} as const;

export type DataTypeEnum3015Key = (typeof dataTypeEnum3015)[keyof typeof dataTypeEnum3015];

export const dataTypeEnum3016 = {
    "folders": "folders"
} as const;

export type DataTypeEnum3016Key = (typeof dataTypeEnum3016)[keyof typeof dataTypeEnum3016];

export const dataTypeEnum3017 = {
    "clients": "clients"
} as const;

export type DataTypeEnum3017Key = (typeof dataTypeEnum3017)[keyof typeof dataTypeEnum3017];

export const includedTypeEnum2081 = {
    "hierarchies": "hierarchies"
} as const;

export type IncludedTypeEnum2081Key = (typeof includedTypeEnum2081)[keyof typeof includedTypeEnum2081];

export const includedTypeEnum2082 = {
    "organizations": "organizations"
} as const;

export type IncludedTypeEnum2082Key = (typeof includedTypeEnum2082)[keyof typeof includedTypeEnum2082];

export const dataTypeEnum3018 = {
    "scopes": "scopes"
} as const;

export type DataTypeEnum3018Key = (typeof dataTypeEnum3018)[keyof typeof dataTypeEnum3018];

export const dataTypeEnum3019 = {
    "trial-summaries": "trial-summaries"
} as const;

export type DataTypeEnum3019Key = (typeof dataTypeEnum3019)[keyof typeof dataTypeEnum3019];

export const dataTypeEnum3020 = {
    "domains": "domains"
} as const;

export type DataTypeEnum3020Key = (typeof dataTypeEnum3020)[keyof typeof dataTypeEnum3020];

export const includedTypeEnum2083 = {
    "teams": "teams"
} as const;

export type IncludedTypeEnum2083Key = (typeof includedTypeEnum2083)[keyof typeof includedTypeEnum2083];

export const dataTypeEnum3021 = {
    "users": "users"
} as const;

export type DataTypeEnum3021Key = (typeof dataTypeEnum3021)[keyof typeof dataTypeEnum3021];

export const dataTypeEnum3022 = {
    "principals": "principals"
} as const;

export type DataTypeEnum3022Key = (typeof dataTypeEnum3022)[keyof typeof dataTypeEnum3022];

export const dataTypeEnum3023 = {
    "offices": "offices"
} as const;

export type DataTypeEnum3023Key = (typeof dataTypeEnum3023)[keyof typeof dataTypeEnum3023];

export const includedTypeEnum2084 = {
    "projects": "projects"
} as const;

export type IncludedTypeEnum2084Key = (typeof includedTypeEnum2084)[keyof typeof includedTypeEnum2084];

export const dataTypeEnum3024 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type DataTypeEnum3024Key = (typeof dataTypeEnum3024)[keyof typeof dataTypeEnum3024];

export const dataTypeEnum3025 = {
    "project-types": "project-types"
} as const;

export type DataTypeEnum3025Key = (typeof dataTypeEnum3025)[keyof typeof dataTypeEnum3025];

export const dataTypeEnum3026 = {
    "owners": "owners"
} as const;

export type DataTypeEnum3026Key = (typeof dataTypeEnum3026)[keyof typeof dataTypeEnum3026];

export const dataTypeEnum3027 = {
    "architects": "architects"
} as const;

export type DataTypeEnum3027Key = (typeof dataTypeEnum3027)[keyof typeof dataTypeEnum3027];

export const dataTypeEnum3028 = {
    "departments": "departments"
} as const;

export type DataTypeEnum3028Key = (typeof dataTypeEnum3028)[keyof typeof dataTypeEnum3028];

export const dataTypeEnum3029 = {
    "regions": "regions"
} as const;

export type DataTypeEnum3029Key = (typeof dataTypeEnum3029)[keyof typeof dataTypeEnum3029];

export const dataTypeEnum3030 = {
    "external-project-links": "external-project-links"
} as const;

export type DataTypeEnum3030Key = (typeof dataTypeEnum3030)[keyof typeof dataTypeEnum3030];

export const includedTypeEnum2085 = {
    "files": "files"
} as const;

export type IncludedTypeEnum2085Key = (typeof includedTypeEnum2085)[keyof typeof includedTypeEnum2085];

export const includedTypeEnum2086 = {
    "folders": "folders"
} as const;

export type IncludedTypeEnum2086Key = (typeof includedTypeEnum2086)[keyof typeof includedTypeEnum2086];

export const includedTypeEnum2087 = {
    "clients": "clients"
} as const;

export type IncludedTypeEnum2087Key = (typeof includedTypeEnum2087)[keyof typeof includedTypeEnum2087];

export const includedTypeEnum2088 = {
    "scopes": "scopes"
} as const;

export type IncludedTypeEnum2088Key = (typeof includedTypeEnum2088)[keyof typeof includedTypeEnum2088];

export const includedTypeEnum2089 = {
    "trial-summaries": "trial-summaries"
} as const;

export type IncludedTypeEnum2089Key = (typeof includedTypeEnum2089)[keyof typeof includedTypeEnum2089];

export const includedTypeEnum2090 = {
    "domains": "domains"
} as const;

export type IncludedTypeEnum2090Key = (typeof includedTypeEnum2090)[keyof typeof includedTypeEnum2090];

export const includedTypeEnum2091 = {
    "users": "users"
} as const;

export type IncludedTypeEnum2091Key = (typeof includedTypeEnum2091)[keyof typeof includedTypeEnum2091];

export const dataTypeEnum3031 = {
    "user-preferences": "user-preferences"
} as const;

export type DataTypeEnum3031Key = (typeof dataTypeEnum3031)[keyof typeof dataTypeEnum3031];

export const includedTypeEnum2092 = {
    "offices": "offices"
} as const;

export type IncludedTypeEnum2092Key = (typeof includedTypeEnum2092)[keyof typeof includedTypeEnum2092];

export const includedTypeEnum2093 = {
    "principals": "principals"
} as const;

export type IncludedTypeEnum2093Key = (typeof includedTypeEnum2093)[keyof typeof includedTypeEnum2093];

export const dataTypeEnum3032 = {
    "members": "members"
} as const;

export type DataTypeEnum3032Key = (typeof dataTypeEnum3032)[keyof typeof dataTypeEnum3032];

export const dataTypeEnum3033 = {
    "principalRoles": "principalRoles"
} as const;

export type DataTypeEnum3033Key = (typeof dataTypeEnum3033)[keyof typeof dataTypeEnum3033];

export const includedTypeEnum2094 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type IncludedTypeEnum2094Key = (typeof includedTypeEnum2094)[keyof typeof includedTypeEnum2094];

export const includedTypeEnum2095 = {
    "project-types": "project-types"
} as const;

export type IncludedTypeEnum2095Key = (typeof includedTypeEnum2095)[keyof typeof includedTypeEnum2095];

export const includedTypeEnum2096 = {
    "owners": "owners"
} as const;

export type IncludedTypeEnum2096Key = (typeof includedTypeEnum2096)[keyof typeof includedTypeEnum2096];

export const includedTypeEnum2097 = {
    "architects": "architects"
} as const;

export type IncludedTypeEnum2097Key = (typeof includedTypeEnum2097)[keyof typeof includedTypeEnum2097];

export const includedTypeEnum2098 = {
    "departments": "departments"
} as const;

export type IncludedTypeEnum2098Key = (typeof includedTypeEnum2098)[keyof typeof includedTypeEnum2098];

export const includedTypeEnum2099 = {
    "regions": "regions"
} as const;

export type IncludedTypeEnum2099Key = (typeof includedTypeEnum2099)[keyof typeof includedTypeEnum2099];

export const includedTypeEnum2100 = {
    "external-project-links": "external-project-links"
} as const;

export type IncludedTypeEnum2100Key = (typeof includedTypeEnum2100)[keyof typeof includedTypeEnum2100];

export const includedTypeEnum2101 = {
    "user-preferences": "user-preferences"
} as const;

export type IncludedTypeEnum2101Key = (typeof includedTypeEnum2101)[keyof typeof includedTypeEnum2101];

export const includedTypeEnum2102 = {
    "members": "members"
} as const;

export type IncludedTypeEnum2102Key = (typeof includedTypeEnum2102)[keyof typeof includedTypeEnum2102];

export const dataTypeEnum3034 = {
    "roles": "roles"
} as const;

export type DataTypeEnum3034Key = (typeof dataTypeEnum3034)[keyof typeof dataTypeEnum3034];

export const dataTypeEnum3035 = {
    "scope-access": "scope-access"
} as const;

export type DataTypeEnum3035Key = (typeof dataTypeEnum3035)[keyof typeof dataTypeEnum3035];

export const includedTypeEnum2103 = {
    "principalRoles": "principalRoles"
} as const;

export type IncludedTypeEnum2103Key = (typeof includedTypeEnum2103)[keyof typeof includedTypeEnum2103];

export type HierarchiesControllerGetChildren200 = {
    /**
     * @type array
    */
    data: {
        /**
         * @type string
        */
        id: string;
        type: DataTypeEnum3011Key;
        /**
         * @description Resource attributes (excluding relationships)
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            type?: AttributesTypeEnum8Key;
            parentId?: (string | null);
            /**
             * @type number | undefined
            */
            depth?: number;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type boolean | undefined
            */
            private?: boolean;
            /**
             * @type string | undefined
            */
            name?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            archivedAt?: (string | null);
            organization?: (object | null);
            team?: (object | null);
            project?: (object | null);
            file?: (object | null);
            folder?: (object | null);
            client?: (object | null);
            /**
             * @type boolean | undefined
            */
            isArchived?: boolean;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3013Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3016Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3017Key;
                });
            };
        };
    }[];
    /**
     * @description Additional resources referenced by the data
     * @type array | undefined
    */
    included?: ({
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2081Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            organization?: string;
            /**
             * @type string | undefined
            */
            team?: string;
            /**
             * @type string | undefined
            */
            project?: string;
            /**
             * @type string | undefined
            */
            file?: string;
            /**
             * @type string | undefined
            */
            folder?: string;
            /**
             * @type string | undefined
            */
            client?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3013Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3016Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3017Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2082Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            trimbleIamAccountId?: string;
            /**
             * @type string | undefined
            */
            trimbleCdhAccountId?: string;
            /**
             * @type string | undefined
            */
            ssoEnabled?: string;
            /**
             * @type string | undefined
            */
            dataProtectionEnabled?: string;
            /**
             * @type string | undefined
            */
            organizationSkillsEnabled?: string;
            /**
             * @type string | undefined
            */
            emsValidationEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedProjectChatEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedContentChatEnabled?: string;
            /**
             * @type string | undefined
            */
            apiAccessEnabled?: string;
            /**
             * @type string | undefined
            */
            isInternal?: string;
            /**
             * @type string | undefined
            */
            enabledIntegrations?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            entitlement?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            trial?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3019Key;
                });
            };
            /**
             * @type object | undefined
            */
            clients?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3017Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            domains?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3020Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            teams?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3013Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            folders?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3016Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            files?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            descendants?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3011Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2083Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            members?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            sourceOffice?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3023Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2084Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            visibility?: string;
            /**
             * @type string | undefined
            */
            stage?: string;
            /**
             * @type string | undefined
            */
            location?: string;
            /**
             * @type string | undefined
            */
            startDate?: string;
            /**
             * @type string | undefined
            */
            endDate?: string;
            /**
             * @type string | undefined
            */
            description?: string;
            /**
             * @type string | undefined
            */
            value?: string;
            /**
             * @type string | undefined
            */
            referenceNumber?: string;
            /**
             * @type string | undefined
            */
            deliverable?: string;
            /**
             * @type string | undefined
            */
            deliveryMethod?: string;
            /**
             * @type string | undefined
            */
            division?: string;
            /**
             * @type string | undefined
            */
            details?: string;
            /**
             * @type string | undefined
            */
            imageUrl?: string;
            /**
             * @type string | undefined
            */
            workflowCount?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            sampleProjectTemplate?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3024Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3017Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectType?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3025Key;
                });
            };
            /**
             * @type object | undefined
            */
            owner?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3026Key;
                });
            };
            /**
             * @type object | undefined
            */
            architect?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3027Key;
                });
            };
            /**
             * @type object | undefined
            */
            department?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3028Key;
                });
            };
            /**
             * @type object | undefined
            */
            region?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3029Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectLead?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            externalLinks?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3030Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2085Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            fileUuid?: string;
            /**
             * @type string | undefined
            */
            originalName?: string;
            /**
             * @type string | undefined
            */
            fileName?: string;
            /**
             * @type string | undefined
            */
            mimeType?: string;
            /**
             * @type string | undefined
            */
            fileSize?: string;
            /**
             * @type string | undefined
            */
            checksum?: string;
            /**
             * @type string | undefined
            */
            bucket?: string;
            /**
             * @type string | undefined
            */
            fileKey?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            fileDocumentType?: string;
            /**
             * @type string | undefined
            */
            processingStartedAt?: string;
            /**
             * @type string | undefined
            */
            processingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            pageCount?: string;
            /**
             * @type string | undefined
            */
            duration?: string;
            /**
             * @type string | undefined
            */
            dimensions?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            version?: string;
            /**
             * @type string | undefined
            */
            versionName?: string;
            /**
             * @type string | undefined
            */
            versionDescription?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            rootFile?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                });
            };
            /**
             * @type object | undefined
            */
            versions?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2086Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2087Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2088Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3013Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3016Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2089Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            projectCount?: string;
            /**
             * @type string | undefined
            */
            projectCap?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2090Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2091Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            phoneNumber?: string;
            /**
             * @type string | undefined
            */
            companyRole?: string;
            /**
             * @type string | undefined
            */
            acceptedTerms?: string;
            /**
             * @type string | undefined
            */
            termsAcceptedAt?: string;
            /**
             * @type string | undefined
            */
            lastLoginAt?: string;
            /**
             * @type string | undefined
            */
            timezone?: string;
            /**
             * @type string | undefined
            */
            avatarUrl?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            changeOrderAccess?: string;
            /**
             * @type string | undefined
            */
            trimbleSub?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            preferences?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3031Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2092Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            uuid?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            isActive?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2093Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            cognitoSubs?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            memberships?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3032Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdFiles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3015Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            roles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3033Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2094Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2095Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2096Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2097Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2098Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2099Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3012Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2100Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            provider?: string;
            /**
             * @type string | undefined
            */
            externalCompanyId?: string;
            /**
             * @type string | undefined
            */
            externalProjectId?: string;
            /**
             * @type string | undefined
            */
            scopeId?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3014Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2101Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            currentTeamId?: string;
            /**
             * @type string | undefined
            */
            theme?: string;
            /**
             * @type string | undefined
            */
            language?: string;
            /**
             * @type string | undefined
            */
            timezoneOverride?: string;
            /**
             * @type string | undefined
            */
            dashboardLayout?: string;
            /**
             * @type string | undefined
            */
            onboardingStatus?: string;
            /**
             * @type string | undefined
            */
            onboardingGoals?: string;
            /**
             * @type string | undefined
            */
            onboardingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            skillsEducationDismissedAt?: string;
            /**
             * @type string | undefined
            */
            onboardingTaskCompletions?: string;
            /**
             * @type string | undefined
            */
            onboardingTasksLoginViews?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            currentTeam?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3013Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2102Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            membershipType?: string;
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string | undefined
            */
            roleName?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            message?: string;
            /**
             * @type string | undefined
            */
            inviteStatus?: string;
            /**
             * @type string | undefined
            */
            isInherited?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3034Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3021Key;
                });
            };
            /**
             * @type object | undefined
            */
            invitedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            inheritedFrom?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            scopeAccess?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3035Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2103Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3022Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3018Key;
                });
            };
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3034Key;
                });
            };
        };
    })[];
    /**
     * @type object | undefined
    */
    meta?: PaginationMeta;
    /**
     * @type object | undefined
    */
    links?: JsonApiLinksDto;
};

/**
 * @description Unauthorized
*/
export type HierarchiesControllerGetChildren401 = any;

/**
 * @description Forbidden - insufficient permissions
*/
export type HierarchiesControllerGetChildren403 = any;

export type HierarchiesControllerGetChildrenQueryResponse = HierarchiesControllerGetChildren200;

export type HierarchiesControllerGetChildrenQuery = {
    Response: HierarchiesControllerGetChildren200;
    PathParams: HierarchiesControllerGetChildrenPathParams;
    QueryParams: HierarchiesControllerGetChildrenQueryParams;
    Errors: HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403;
};